<template>
	<div
		class="base-menu-list"
		:class="{
			'base-menu-list--has-label': !!label,
		}"
	>
		<div v-if="!!label" class="base-menu-list__label">{{ label }}</div>

		<ul class="base-menu-list__list">
			<slot />
		</ul>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		label: {
			type: String,
			default: null,
		},
	},
});
</script>

<style lang="scss">
.base-menu-list {
	position: relative;

	&__list {
		line-height: 1.28;
	}

	&__label {
		display: block;
		margin-bottom: 0.5rem;
		color: #666;
		font-size: 0.8em;
		font-weight: 500;
	}

	& + & {
		margin-top: 1.5rem;
		padding-top: 1.5rem;

		&::before {
			content: '';
			display: block;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			border-top: 1px solid #eaeaea;
		}
	}
}
</style>
